import { render, staticRenderFns } from "./SayfaGuncelle.vue?vue&type=template&id=ff0e1c42&scoped=true&"
import script from "./SayfaGuncelle.vue?vue&type=script&lang=js&"
export * from "./SayfaGuncelle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0e1c42",
  null
  
)

export default component.exports